export const competitorProductAnalytics = {
    getList,
    getProductsByPartNumber
};

async function getList(
    perPage,
    currentPage
) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    let limit = perPage;
    let offset = 0;

    if (currentPage > 1) {
        offset = perPage * currentPage - 1;
    }

    let url = `${process.env.VUE_APP_API_URL}/api/competitor-products/analytics?limit=${limit}&offset=${offset}`;

    return await fetch(url, requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function getProductsByPartNumber(
    partNumber,
    perPage,
    currentPage
) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    let limit = perPage;
    let offset = 0;

    if (currentPage > 1) {
        offset = perPage * currentPage - 1;
    }

    let url = `${process.env.VUE_APP_API_URL}/api/competitor-products/product-analytics?limit=${limit}&offset=${offset}&part_number=${partNumber}`;

    return await fetch(url, requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}